import Cookies from 'js-cookie';
import { ADMIN_LOGIN_RETURNING_KEY } from '../constants/adminLoginStorage';

// Must match apps/backend/src/platform-billing/subscription-access.ts exactly.
export const ACCOUNT_INACTIVE_MESSAGE =
  'This account is inactive. Please contact your administrator.';
export const SUBSCRIPTION_REMOVED_MESSAGE =
  'Your SAS Cleaning Suite subscription was removed. Subscribe again at sascleaningsuite.com to restore access.';
export const SUBSCRIPTION_ENDED_MESSAGE =
  'Your subscription has ended. Reactivate it in Billing & Subscription to continue.';

/** window event: detail = { access: 'full' | 'ended' | 'blocked', message? } */
export const BILLING_ACCESS_EVENT = 'sas:billing-access';

/** Stripe statuses that keep full access (mirrors LIVE_SUBSCRIPTION_STATUSES on the backend). */
export const isLiveSubscriptionStatus = (status) =>
  ['active', 'trialing', 'past_due', 'incomplete'].includes(status);

export const announceBillingAccess = (access, message) =>
  window.dispatchEvent(new CustomEvent(BILLING_ACCESS_EVENT, { detail: { access, message } }));

/** graphqlRequest calls this with every error message so the app can react app-wide. */
export function reportAccessError(message) {
  if (message === SUBSCRIPTION_ENDED_MESSAGE) announceBillingAccess('ended');
  else if (message === ACCOUNT_INACTIVE_MESSAGE || message === SUBSCRIPTION_REMOVED_MESSAGE) {
    announceBillingAccess('blocked', message);
  }
}

export function logoutAdmin() {
  const returningFlag = localStorage.getItem(ADMIN_LOGIN_RETURNING_KEY);
  Cookies.remove('accessToken');
  Cookies.remove('userId');
  Cookies.remove('companyId');
  Cookies.remove('companyName');
  localStorage.clear();
  if (returningFlag === '1') {
    localStorage.setItem(ADMIN_LOGIN_RETURNING_KEY, '1');
  }
  window.location.href = '/login';
}
